type GradeCalculationRecommendationParams = {
  classId: number;
  studentId: number;
  from?: string;
  to?: string;
};

type GradeCalculationClassRecommendationParams = Omit<GradeCalculationRecommendationParams, 'studentId'> & {
  subjectIds?: number[];
};

type GradeCalculationSubjectRecommendationParams = GradeCalculationRecommendationParams & {
  subjectId: number;
};

export const gradeCalculationKeys = {
  all: ['gradeCalculation'] as const,

  settings: (tenantId: number | null | undefined) => [...gradeCalculationKeys.all, 'settings', tenantId],

  scaleUsage: (tenantId: number | undefined) => [...gradeCalculationKeys.all, 'scaleUsage', tenantId],

  summaries: (params: GradeCalculationRecommendationParams) =>
    [
      ...gradeCalculationKeys.all,
      'summaries',
      params.classId,
      params.studentId,
      params.from ?? null,
      params.to ?? null,
    ] as const,

  recommendation: (params: GradeCalculationSubjectRecommendationParams) =>
    [
      ...gradeCalculationKeys.all,
      'recommendation',
      params.classId,
      params.studentId,
      params.subjectId,
      params.from ?? null,
      params.to ?? null,
    ] as const,

  classRecommendations: (params: GradeCalculationClassRecommendationParams) =>
    [
      ...gradeCalculationKeys.all,
      'classRecommendations',
      params.classId,
      params.subjectIds ?? null,
      params.from ?? null,
      params.to ?? null,
    ] as const,
} as const;
